import React from 'react'
import PropTypes from "prop-types"
import { Container } from 'reactstrap'
import './style.css'

const zDepthClasses = {
    0: "Paper-paper0",
    1: "Paper-paper1",
    2: "Paper-paper2",
    3: "Paper-paper3"
}

const raisedClasses = {
    0: "Paper-raised0",
    1: "Paper-raised1",
    2: "Paper-raised2",
    3: "Paper-raised3"
}

const Paper = ({ children, className, zDepth, raised, onClick, style }) => {
    zDepth = zDepth != null ? zDepth : 1;

    return (
        <Container
            onClick={onClick}
            style={style}
            className={[className, "Paper-paper", zDepthClasses[zDepth], raised != null ? raisedClasses[raised] : ""].join(" ")}
        >
            {children}
        </Container>
    )
}

Paper.propTypes = {
    style: PropTypes.object,
    zDepth: PropTypes.oneOf([0, 1, 2, 3]),
    className: PropTypes.string,
    raised: PropTypes.oneOf([0, 1, 2, 3])
}


export default Paper;


// WEBPACK FOOTER //
// ./src/components/simple/Paper/index.js